module.exports = __webpack_public_path__ + "img/schedule6.4e4c2230.png";